module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lyra/lyr_fig-9093cf562ce82e33b0e56d68395f097f.gif";